module.exports = __webpack_public_path__ + "img/introduce_01.9cbb777e.png";